import React from 'react';
import { BookOpen } from 'lucide-react';

interface WebtoonLogoProps {
  size?: number;
  className?: string;
}

export const WebtoonLogo: React.FC<WebtoonLogoProps> = ({ size = 24, className = "" }) => {
  return (
    <div
      className={`flex items-center justify-center bg-[#00d564] rounded-lg shadow-sm shadow-[#00d564]/20 ${className}`}
      style={{ width: size, height: size }}
    >
      <BookOpen
        size={size * 0.56}
        className="text-white"
        fill="white"
        strokeWidth={2.5}
      />
    </div>
  );
};
